export default {
      id: "googledbm-usage",
      viewBox: "0 0 23 18",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#googledbm-usage",
      toString: function () {
        return this.url;
      }
    }